import { actions } from "./state-actions";
import { getters } from "./state-getters";
import { mutations } from "./state-mutations";
import * as StoreTypes from "./state-types";

//const debug: boolean = true; // process.env.NODE_ENV !== 'production';


import { Module, StoreOptions } from "vuex";

const namespaced: boolean = true;

export const state: StoreTypes.IState = {
    activeUser: null,
    currentModelId: "",
    capabilities: null,
    currentNodePath: "",
    nodeModifiedNotification: ""


    //    currentModelId: "",
    //  modelIsActive: false
};

export const profile: Module<StoreTypes.IState, StoreTypes.IRootState> =
{
    namespaced,
    state,
    getters,
    actions,
    mutations
};


export const store: StoreOptions<StoreTypes.IRootState> = {
    state: {
        version: '1.0.0' // a simple property
    },
    modules: {
        profile
    }
};




// WEBPACK FOOTER //
// ./ClientApp/infrastructure/state/state-store.ts